import types from "./types";

const INITIAL_STATE = {
  logList: null,
  logListError: null,
  logListLoading: false,

  //create
  createlog: null,
  createlogError: null,
  createlogLoading: false,

  //update
  updatelog: null,
  updatelogError: null,
  updatelogLoading: false,

  //delete
  deletelog: null,
  deletelogError: null,
  deletelogLoading: false,

  //single item
  singleItem: null,
};

const logReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_LOG_START:
      return {
        ...state,
        logList: null,
        logListError: null,
        logListLoading: true,
      };
    case types.GET_LOG_SUCCESS:
      return {
        ...state,
        logList: action.payload,
        logListLoading: false,
      };
    case types.GET_LOG_ERROR:
      return {
        ...state,
        logListError: action.payload,
        logListLoading: false,
      };
    case types.GET_LOG_RESET:
      return {
        ...state,
        logListError: null,
        logListLoading: false,
      };
    //create

    case types.CREATE_LOG_START:
      return {
        ...state,
        createlog: null,
        createlogError: null,
        createlogLoading: true,
      };
    case types.CREATE_LOG_SUCCESS:
      return {
        ...state,
        createlog: action.payload,
        createlogLoading: false,
      };
    case types.CREATE_LOG_ERROR:
      return {
        ...state,
        createlogError: action.payload,
        createlogLoading: false,
      };
    case types.CREATE_LOG_RESET:
      return {
        ...state,
        createlogError: null,
        createlogLoading: false,
      };
    //delete

    case types.DELETE_LOG_START:
      return {
        ...state,
        deletelog: null,
        deletelogError: null,
        deletelogLoading: true,
      };
    case types.DELETE_LOG_SUCCESS:
      return {
        ...state,
        deletelog: action.payload,
        deletelogLoading: false,
      };
    case types.DELETE_LOG_ERROR:
      return {
        ...state,
        deletelogError: action.payload,
        deletelogLoading: false,
      };
    case types.DELETE_LOG_RESET:
      return {
        ...state,
        deletelog: null,
        deletelogError: null,
        deletelogLoading: false,
      };

    //update
    case types.UPDATE_LOG_START:
      return {
        ...state,
        updatelog: null,
        updatelogError: null,
        updatelogLoading: true,
      };
    case types.UPDATE_LOG_SUCCESS:
      return {
        ...state,
        updatelog: action.payload,
        updatelogLoading: false,
      };
    case types.UPDATE_LOG_ERROR:
      return {
        ...state,
        updatelogError: action.payload,
        updatelogLoading: false,
      };
    case types.UPDATE_LOG_RESET:
      return {
        ...state,
        updatelog: null,
        updatelogError: null,
        updatelogLoading: false,
      };
    //singleItem
    case types.SINGLE_LOG_START:
      return {
        ...state,
        singleItem: null,
        singleItemError: null,
        singleItemLoading: true,
      };
    case types.SINGLE_LOG_SUCCESS:
      return {
        ...state,
        singleItem: action.payload,
        singleItemLoading: false,
      };
    case types.SINGLE_LOG_ERROR:
      return {
        ...state,
        singleItemError: action.payload,
        singleItemLoading: false,
      };
    case types.SINGLE_LOG_RESET:
      return {
        ...state,
        singleItem: null,
        singleItemError: null,
        singleItemLoading: false,
      };

    default:
      return { ...state };
  }
};

export default logReducer;

